import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Snackbar, SnackbarContent } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { useVersionCheck } from './util/useVersionCheck';

export const VersionChecker: React.FC = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const { t } = useTranslationWithPrefix('components.versionChecker');
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    if (previousPathnameRef.current !== pathname && isNewVersionAvailable) {
      globalThis.location.reload();
    }
    previousPathnameRef.current = pathname;
  }, [isNewVersionAvailable, pathname]);

  const handleReload = () => {
    globalThis.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={isNewVersionAvailable}
    >
      <SnackbarContent
        action={
          <Button
            color="secondary"
            onClick={handleReload}
            size="small"
            startIcon={<RefreshIcon />}
            variant="contained"
          >
            {t('refresh')}
          </Button>
        }
        message={t('newVersionAvailable')}
        variant="elevation"
      />
    </Snackbar>
  );
};
